"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageUpload = ImageUpload;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const antd_img_crop_1 = __importDefault(require("antd-img-crop"));
const icons_1 = require("@ant-design/icons");
const styled_components_1 = __importDefault(require("styled-components"));
const react_intl_1 = require("react-intl");
const Modal_1 = require("../Modal");
function getBase64(img) {
    return new Promise(resolve => {
        const reader = new FileReader();
        reader.addEventListener('load', () => resolve(reader.result));
        reader.readAsDataURL(img);
    });
}
const StyledImg = styled_components_1.default.img `
	width: 100%;
`;
function ImageUpload({ name, cropSize, accept, aspect, beforeUpload, wholeFileList, setFileList, modalTitle, minZoom = 0.1, }) {
    const [preview, setPreview] = react_1.default.useState({
        image: '',
        visible: false,
        title: '',
    });
    const handlePreview = async (file) => {
        var _a;
        let filePreview = '';
        if (file.thumbUrl) {
            filePreview = file.thumbUrl;
        }
        else if (!file.url && !file.preview && !filePreview) {
            filePreview = await getBase64(file.originFileObj);
        }
        setPreview({
            image: file.url || filePreview,
            visible: true,
            title: file.name || ((_a = file.url) === null || _a === void 0 ? void 0 : _a.substring(file.url.lastIndexOf('/') + 1)) || 'Image',
        });
    };
    const handleCancelPreview = () => {
        setPreview({ ...preview, visible: false });
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(antd_img_crop_1.default, { aspect: aspect, modalTitle: modalTitle, minZoom: minZoom, grid: true, quality: 0.85, 
                // @ts-ignore
                cropperProps: { cropSize: cropSize, restrictPosition: false }, children: (0, jsx_runtime_1.jsx)(antd_1.Upload, { beforeUpload: beforeUpload, action: file => getBase64(file), maxCount: 1, listType: "picture-card", onChange: ({ fileList }) => {
                        setFileList(fileList);
                    }, onPreview: handlePreview, accept: accept, name: name, fileList: wholeFileList, children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(icons_1.PlusOutlined, {}), (0, jsx_runtime_1.jsx)("div", { className: "m-t-s", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "registration.registration_form.upload", defaultMessage: "Upload" }) })] }) }) }), (0, jsx_runtime_1.jsx)(Modal_1.Modal, { visible: preview.visible, title: preview.title, footer: null, onCancel: handleCancelPreview, children: (0, jsx_runtime_1.jsx)(StyledImg, { alt: "preview", src: preview.image }) })] }));
}
